<!-- eslint-disable  -->
<template>
  <div class="w-100">
    <!-- START Navigation and related information -->
    <div id="nav-info" role="navigation" class="container-fluid fixed-top w-100 px-0">
      <interview-navi :navData="navData"></interview-navi>
      <div class="position-relative export-dropdown-col-checkout" v-if="!(isAutoRC2Error && isHomeRC2Error)">
        <div class="select-box-col">
          <input-select :fieldData="exportDropdown" :ref="exportDropdown.field_name" :exportPDF="exportPDF"></input-select>
        </div>
      </div>
    </div>
    <div role="main" :class="{ 'quote-panel-open': quotePanelStatus, 'quote-panel-close': !quotePanelStatus, 'bundle' : flowType === 'bundle' || flowType === 'cabundle' || flowType === 'rabundle'}">
      <!-- START Content Wrapper -->
      <div class="row no-gutters mx-0">
        <div class="col">
          <div class="row my-3">
            <div id="homeCol" class="col-12 col-xl-6 b-border-right pl-3 pr-4" :class="{'bound' : this.$store.getters.getHomeBindStatus && this.$store.getters.getHomeBindStatus.Status === 'Success'}">
              <div v-if="getHomeCarrier && getHomeCarrier.carrier_type === 'EZLYNXCARRIER'"></div>
              <div v-else-if="getHomeCarrier && showHomeForceBindMsg">
                <bundle-carrier-error :errorData="homeForceBindMsg"></bundle-carrier-error>    
              </div>
              <home-checkout v-else-if="getHomeCarrier"></home-checkout>
              <div v-else>
                <bundle-carrier-error :errorData="homeBundleCarrierError"></bundle-carrier-error>                
              </div>
            </div>
            <div class="col-12 col-xl-6 pl-4 pr-3" :class="{'bound' : this.$store.getters.getAutoBindStatus && this.$store.getters.getAutoBindStatus.Status === 'Success'}">
              <div v-if="getAutoCarrier && getAutoCarrier.carrier_type === 'EZLYNXCARRIER'"></div>
              <div v-else-if="getAutoCarrier && showAutoForceBindMsg">
                <bundle-carrier-error :errorData="autoForceBindMsg"></bundle-carrier-error>    
              </div>
              <auto-checkout v-else-if="getAutoCarrier"></auto-checkout>
              <div v-else>
                <bundle-carrier-error :errorData="autoCundleCarrierError"></bundle-carrier-error>                
              </div>
            </div>
          </div>
        </div>
      </div>      
      <div class="row justify-content-center b-fixed-row no-gutters" :class="{'margin-25' : quotePanelStatus}" v-if="showIndividualBindAlert">
        <div class="col-6 text-center bundle-policy-bound-alert" v-if="this.$store.getters.getHomeBindStatus && this.$store.getters.getHomeBindStatus.Status === 'Success'">
          <div role="alert" aria-atomic="true" class="p-3 m-0 rounded-0 text-left alert alert-warning border-bottom-0 border-left-0">
            <p><strong>Policy Bound:</strong>This policy has been completed and bound. Any attempted changes to this policy will not be saved. Contact your manager if this policy was saved with incorrect information.</p>
          </div>
        </div>
        <div class="col-6 text-center py-3">
          <button type="submit" class="btn btn-primary btn purchase-btn" :class = "{'disabled' : (isAutoRC2Error || isHomeRC2Error)}" @click.prevent="bundleSubmitProperty('submit')" v-if="showPurchaseButton">{{ submitButtonLabel }}</button>
        </div>
        <div class="col-6 text-center bundle-policy-bound-alert" v-if="this.$store.getters.getAutoBindStatus && this.$store.getters.getAutoBindStatus.Status === 'Success'">
          <div role="alert" aria-atomic="true" class="p-3 m-0 rounded-0 text-left alert alert-warning border-bottom-0 border-right-0">
            <p class="m-0"><strong>Policy Bound:</strong>This policy has been completed and bound. Any attempted changes to this policy will not be saved. Contact your manager if this policy was saved with incorrect information.</p>
          </div>
        </div>
      </div>
      <div v-else-if="showPurchaseButton" class="form-row justify-content-center b-fixed-row" :class="{'margin-25' : quotePanelStatus}" >
        <div class="col-8 text-center">
          <button type="submit" class="btn btn-primary btn my-3" @click.prevent="bundleSubmitProperty('submit')">{{ submitButtonLabel }}</button>
        </div>
      </div>
    </div>
    <b-modal ref="confirm-policy-bind" hide-header hide-footer hide-header-close no-enforce-focus>
      <Trap>
        <div class="policy-confirmation-box">
          <div class="policy-modal-message mb-3">
            <div>{{ confirmMsg }}</div>
          </div>
          <div class="policy-btn-box d-flex justify-content-between">
            <b-button class="mt-3 policy-btn-cancel" block @click="closeRemoveModal('confirm-policy-bind')">Cancel</b-button>
            <b-button class="mt-3 policy-btn-confirm" block @click="bundleSubmitProperty('confirm')"> {{ popupButtonLable }}</b-button>
          </div>
        </div>
      </Trap>
    </b-modal>
    <!-- <dev-auto-fill :pageData="pageData"></dev-auto-fill> -->
    <!-- Bound Policy Alert -->
    <form-alerts v-if="showBoundAlert"
      :pageData="policyBindError" :class="{'policy-bound-alert': true, 'margin-25' : quotePanelStatus}"></form-alerts>
  </div>
  <!-- END Content Wrapper -->
</template>

<script>
/* eslint-disable */
import InterviewNavigation from './Navigation';
import { rulesMixin } from '../../../mixins/rulesMixin';
import { pageMixin } from '../../../mixins/pageMixin';
import AutoCheckout from './AutoCheckout';
import HomeCheckout from './HomeCheckout';
import BundleCarrierError from './BundleCarrierError';
import FormAlerts from '../../presentational/alerts/FormAlerts';
import InputSelect from '../../interactive/InputSelect';

export default {
  mixins: [pageMixin, rulesMixin],
  data() {
    return {     
      pageData: {},
      homePageData: {},
      vgsForm: {},
      homeVgsForm: {},
      homeCurrentPaymentFieldsOrder: {},
      currentPaymentFieldsOrder: {},
      autoCundleCarrierError : {
        msg: 'An error has occurred. You could have additional savings if you bundle! Select another carrier in the carrier matches page to bundle.',
        showCarrierLogo: false
      },
      homeBundleCarrierError : {
        msg: 'An error has occurred. You could have additional savings if you bundle! Select another carrier in the carrier matches page to bundle.',
        showCarrierLogo: false
      },
      autoForceBindMsg : {
        forceBind: true,
        msg: '<strong>Policy Bound:</strong> This policy has been completed and bound. Any attempted changes to this policy will not be saved. Contact your manager if this policy was saved with incorrect information.',
        showCarrierLogo: true,
        // logoPathSvg: 'https://dev.insurance.com/insurance/media/carrier/ucp/svgLogos/prog_ucp_logo.svg'
      },
      homeForceBindMsg : {
        forceBind: true,
        msg: '<strong>Policy Bound:</strong> This policy has been completed and bound. Any attempted changes to this policy will not be saved. Contact your manager if this policy was saved with incorrect information.',
        showCarrierLogo: true,
        // logoPathSvg: 'https://dev.insurance.com/insurance/media/carrier/ucp/svgLogos/prog_ucp_logo.svg'
      },
      confirmMsg : '',
      homeAckFields : ['QTE_PRP_AgencyESDDAStatement','QTE_PRP_AgencyOTEFTStatement'],// 'QTE_PRP_AgencyOneTimeTextDisclaimer', 'QTE_PRP_TCPA'],
      autoAckFields : ['QTE_CAR_AgencyESDDAStatement', 'QTE_CAR_AgencyOTEFTStatement'], //'QTE_VehOperationAcknowledgement', 'QTE_MonthlyPaymentAcknowledgement', 'QTE_PolicyCoverageAcknowledgement'],      
      exportDropdown : {
        "field_name": "QTE_PRP_ExportPDF",
        "field_type": "select_medium",
        "label": "Share Quote Summary",
        "field_value": "",
        "help_text": "",
        "sub_text": "",
        "placeholder": "Share Quote Summary",
        "visible": true,
        "is_enabled": true,
        "is_required": false,
        "rules": [],
        "values": [
            {
                "display_value": "Print PDF",
                "internal_value": "printpdf",
                "visible": true,
                "display_order": 1
            },
            // {
            //     "display_value": "Email PDF",
            //     "internal_value": "emailpdf",
            //     "visible": true,
            //     "display_order": 2
            // }
        ],
        "has_error": false,
        "error": null
      },
    };
  },
  components: {
    interviewNavi: InterviewNavigation,
    AutoCheckout,
    HomeCheckout,
    BundleCarrierError,
    FormAlerts,
    InputSelect,
  },
  computed: {
    showAutoForceBindMsg() {
      this.autoForceBindMsg.logoPathSvg = this.getAutoCarrier ? this.getAutoCarrier.logoPathSvg : '';
      let autoBindDetails = sessionStorage.getItem('autoBindDetails') ? JSON.parse(sessionStorage.getItem('autoBindDetails')) : {};
      return sessionStorage.getItem('autobound') == 'true' && (autoBindDetails && autoBindDetails.quote_bind_type === 'Forced');
    },
    showHomeForceBindMsg() {
      this.homeForceBindMsg.logoPathSvg = this.getHomeCarrier ? this.getHomeCarrier.logoPathSvg : '';
      let homeBindDetails = sessionStorage.getItem('homeBindDetails') ? JSON.parse(sessionStorage.getItem('homeBindDetails')) : {};
      return sessionStorage.getItem('homebound') == 'true' && (homeBindDetails && homeBindDetails.quote_bind_type === 'Forced');
    },
    showBoundAlert() {
      let show = false;
      if (sessionStorage.getItem('homebound') == 'true' && sessionStorage.getItem('autobound') == 'true') {
        show = true;
      } else if (sessionStorage.getItem('homebound') == 'true' && (this.getAutoCarrier && this.getAutoCarrier.carrier_type === 'EZLYNXCARRIER' || this.$store.getters.getAutoLinkButtunStatus)) {
        show = true;
      } else if (sessionStorage.getItem('autobound') == 'true' && (this.getHomeCarrier && this.getHomeCarrier.carrier_type === 'EZLYNXCARRIER' || this.$store.getters.getHomeLinkButtunStatus)) {
        show = true;
      } else if (sessionStorage.getItem('autobound') == 'true' && !this.getHomeCarrier) {
        show = true;
      } else if (sessionStorage.getItem('homebound') == 'true' && !this.getAutoCarrier) {
        show = true;
      }
      console.log('show==', show);
      return show;
    },
    // displaySubmitButton() {
    //   return (this.getHomeCarrier || this.getAutoCarrier) && (!this.isAutoRC2Error || !this.isHomeRC2Error) && ((this.$store.getters.getHomeBindStatus && this.$store.getters.getHomeBindStatus.Status !== 'Success' && !this.$store.getters.getHomeLinkButtunStatus) || (this.$store.getters.getAutoBindStatus && this.$store.getters.getAutoBindStatus.Status !== 'Success' && !this.$store.getters.getAutoBindStatus));
    // },
    popupButtonLable() {
      if(this.isAutoRC2Error) {
        return 'Purchase Home Policy Only';
      } else {
        return 'Purchase Auto Policy Only';
      }
    },    
    isAutoRC2Error() {
      return this.$store.getters.getAutoRC2Status === 'success' ? false : true;
    },
    isHomeRC2Error() {
      return this.$store.getters.getHomeRC2Status === 'success' ? false : true;
    },
    getHomeCarrier() {
      return sessionStorage.getItem('selectedCarrierHome') != null ? JSON.parse(sessionStorage.getItem('selectedCarrierHome')) : false;
    },
    getAutoCarrier() {
      return sessionStorage.getItem('selectedCarrierAuto') != null ? JSON.parse(sessionStorage.getItem('selectedCarrierAuto')) : false;    
    },
    navData() {
      if (this.getAutoCarrier) {
        return this.pageData;
      } else {
        return this.homePageData;
      }
    },
    submitButtonLabel() {
      let btn = 'Purchase Policies';
      if (!(this.pageData.fields && this.pageData.fields.length > 0) || !(this.homePageData.fields && this.homePageData.fields.length > 0) ) {
        btn = 'Purchase Policy';
      }
      return btn;
    },
    showPurchaseButton() {
      let showButton = true;
      
      /**
       * if both carrier success and both have QTE_CAR_CarrierURL then hide btn
       * if home have success and QTE_CAR_CarrierURL and auto is not success then hide btn
       * if auto have success and QTE_CAR_CarrierURL and home is not success then hide btn
       */
      if (!(this.isHomeRC2Error && this.isAutoRC2Error) && this.getHomeCarrier && this.$store.getters.getHomeLinkButtunStatus && this.getAutoCarrier && this.$store.getters.getAutoLinkButtunStatus) {
        showButton = false;
      } else if (this.getHomeCarrier && !this.isHomeRC2Error && this.$store.getters.getHomeLinkButtunStatus && (!this.getAutoCarrier || (this.getAutoCarrier && this.isAutoRC2Error || this.getHomeCarrier && this.$store.getters.getAutoBindStatus && this.$store.getters.getAutoBindStatus.Status === 'Success'))) {
        showButton = false;
      } else if ((!this.getHomeCarrier || (this.getHomeCarrier && this.isHomeRC2Error || this.$store.getters.getHomeBindStatus && this.$store.getters.getHomeBindStatus.Status === 'Success')) && this.getAutoCarrier && !this.isAutoRC2Error  && this.$store.getters.getAutoLinkButtunStatus) {
        showButton = false;
      }
      return showButton;
    },
    showIndividualBindAlert(){
      return (this.getHomeCarrier && this.getHomeCarrier.carrier_type !== 'EZLYNXCARRIER' && this.getAutoCarrier && this.getAutoCarrier.carrier_type !== 'EZLYNXCARRIER') && ((this.$store.getters.getHomeBindStatus && this.$store.getters.getHomeBindStatus.Status !== 'Success' && this.$store.getters.getAutoBindStatus && this.$store.getters.getAutoBindStatus.Status === 'Success' && !this.$store.getters.getHomeLinkButtunStatus) || (this.$store.getters.getHomeBindStatus && this.$store.getters.getHomeBindStatus.Status === 'Success' && this.$store.getters.getAutoBindStatus && this.$store.getters.getAutoBindStatus.Status !== 'Success' && !this.$store.getters.getAutoLinkButtunStatus));
    },
  },
  methods: {
    exportPDF() {          
      let carriers = [];
      if (this.getAutoCarrier && this.getAutoCarrier.carrier_type === 'RATECARRIER' && !this.isAutoRC2Error) {
        let temp = {};
        temp.carrier_id = this.getAutoCarrier.carrier_id;
        temp.carrierType = 'auto';
        carriers.push(temp);
      }
      if (this.getHomeCarrier && this.getHomeCarrier.carrier_type === 'RATECARRIER' && !this.isHomeRC2Error) {
        let temp = {};
        temp.carrier_id = this.getHomeCarrier.carrier_id;
        temp.carrierType = 'home';
        carriers.push(temp);
      }
      this.exportPDFTo(this.exportDropdown.field_value, carriers, 'rc3');
    },
    bundleSubmitProperty(submitFrom) {
      let flow = 'Home';
      if (this.flowType === 'cabundle') {
        flow = 'Condo';
      } else if (this.flowType === 'rabundle') {
        flow = 'Renters';
      }
      let homeError = this.isHomeRC2Error ? `Are you sure you want to purchase only the Auto policy without ${flow}?` : false;
      let autoError = this.isAutoRC2Error ? `Are you sure you want to purchase only the ${flow} policy without Auto?` : false;

      //Submit with either home or auto error
      if (submitFrom == 'submit' && (autoError || homeError)) {
        this.confirmMsg = autoError ? autoError : homeError;
        this.$refs['confirm-policy-bind'].show();
      } else if (submitFrom === 'confirm') {
        //after click on confirm
        this.$refs['confirm-policy-bind'].hide();  
        if (autoError && !homeError && !(this.$store.getters.getHomeBindStatus && this.$store.getters.getHomeBindStatus.Status === 'Success')) {
          console.log('home confirm submit');
          this.vgsBundleSubmitProperty();
        } else if (!autoError && homeError && !(this.$store.getters.getAutoBindStatus && this.$store.getters.getAutoBindStatus.Status === 'Success')) {
          console.log('auto confirm submit');
          this.vgsSubmit();
        }
      } else {
        //normal submit without any error 
        //if home is not selected then auto will submit from else
        if (this.getHomeCarrier && !(this.$store.getters.getHomeBindStatus && this.$store.getters.getHomeBindStatus.Status === 'Success') && !this.$store.getters.getHomeLinkButtunStatus) {
          console.log('bundle normal submit');
          this.vgsBundleSubmitProperty();
        } else {
          if(!(this.$store.getters.getAutoBindStatus && this.$store.getters.getAutoBindStatus.Status === 'Success')) {
            console.log('auto normal submit');
            this.vgsSubmit();
          }
        }
      }
    },
    returnToCarrierMatch() {     
      let AUQuoteId = JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId;
      let newRoute = '/auto/carrier-matches';
      let cuurentNav = '/pages/carriermatches/' + AUQuoteId;
      this.$store.dispatch('setCurrentNav', cuurentNav);
      this.$router.push(newRoute);
    },
    handlePageData(pageData) {
      this.pageData = pageData;
    },
    handleHomePageData(pageData) {
      this.homePageData = pageData;
    },
    handleVgsformData(vgsformData) {
      this.vgsForm = vgsformData;
    },
    handlehomeVgsFormData(vgsformData) {
      this.homeVgsForm = vgsformData;
    },
    handleHomeCurrentPaymentFieldsOrder(order) {
      this.homeCurrentPaymentFieldsOrder = order;
    },
    handleCurrentPaymentFieldsOrder(order) {
      this.currentPaymentFieldsOrder = order;
    }
  },
  created() {
    this.flowType = sessionStorage.getItem('flowType');
    this.$store.commit('setHomeLinkButtunStatus', false);
    this.$store.commit('setAutoLinkButtunStatus', false);
  },
  mounted() {
    this.$root.$on("pageDataUpdate", this.handlePageData);
    this.$root.$on("homePageDataUpdate", this.handleHomePageData);
    this.$root.$on("vgsformUpdate", this.handleVgsformData);
    this.$root.$on("homeVgsFormUpdate", this.handlehomeVgsFormData);
    this.$root.$on("homeCurrentPaymentFieldsOrderUpdate", this.handleHomeCurrentPaymentFieldsOrder);
    this.$root.$on("currentPaymentFieldsOrderUpdate", this.handleCurrentPaymentFieldsOrder);
  },
  watch: {
    'pageData': function fieldValue(newValue) {
      
    },
    'homePageData': function fieldValue(newValue) {
      
    },
  },
  beforeDestroy() {
  },
};
</script>
<style scoped lang="scss">
  .bound {
    opacity: 0.35;
    pointer-events: none;
  }
  .b-border-right {
    border-right: 1px solid #CCC;
  }
  .b-fixed-row {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #F9F9F9;
    //padding: 16px 27px;
    box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.14);
    z-index: 9;
    &.margin-25 {
      width: 75.5%;
      -webkit-transition: width 500ms;
      transition: width 500ms;
    }
    .btn:focus {
      box-shadow:none
    }
  }
  .purchase-btn.disabled{
    color: #fff !important;
    background-color: #949494 !important;
    border-color: #949494 !important;
    pointer-events: none;
  }
  .policy-confirmation-box{
    .policy-modal-message {
      color: #000;
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
    }
    .policy-btn-cancel, .policy-btn-cancel:active {
      height: 34px;
      padding: 8px 24px;

      border-radius: 4px;
      background: #949494;
      color: #FFF;
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      border-color: #949494;
      text-transform: none !important;
      width: 20%;
      display: inline-block;
      &:focus {
        box-shadow:none
      }
    }
    .policy-btn-confirm, .policy-btn-confirm:active {
      height: 34px;
      padding: 8px 24px;
      
      border-radius: 4px;
      border: 1px solid #00234F;
      background: #00234F;
      color: #FFF;
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      text-transform: none !important;
      width: 45%;
      display: inline-block;
      &:focus {
        box-shadow:none
      }
    }
  }
  .bundle-policy-bound-alert .alert::before {
    float: left;
    margin-top: 10px;
  }
  .bundle-policy-bound-alert .alert::before {
    font-family: "Font Awesome 5 Pro", "Font Awesome 5 Free";
    font-weight: 600;
    content: "\F071";
    margin-right: 1rem;
  }
</style><style>
  .export-dropdown-col-checkout .select-box-col {    
    position: absolute;
    right: 18px;
    top: 38px;
  }  
  .export-dropdown-col-checkout .btn-group.btn-group-toggle {
    width: 180px;
    position: relative;
    /* right: -64px; */
  }
  .export-dropdown-col-checkout .dropdown.single {
    width: 100%;
  }
  .export-dropdown-col-checkout .dropdown-menu {
    width: 100% !important;
  }
  .vs__selected-options input::placeholder{
    color: #1A1A1A !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/interview/shared/BundleCheckout.vue?32e53820